import React from 'react';
import { Routes, Route } from 'react-router-dom';
import ScrollToTop from "./components/ScrollToTop";
import logo from './logo.svg';
import './App.css';

import useLenis from "./hooks/useLenis";

import Home from './pages/Home';
import About from './pages/About';
import Testimonials from './pages/Testimonials';
import OurTeam from './pages/OurTeam';
import OurServices from './pages/OurServices';
import WebDesignDevelopment from './pages/WebDesignDevelopment';
import DigitalMarketing from './pages/DigitalMarketing';
import GraphicDesigning from './pages/GraphicDesigning';
import HostingSupport from './pages/HostingSupport';
import WebsiteCare from './pages/WebsiteCare';
import Portfolio from './pages/Portfolio';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Contact from './pages/Contact';

import Header from './components/Header';
import Footer from './components/Footer';
import WhatsAppButton from "./components/WhatsAppButton";
import Services from './pages/OurServices';



const App = () => {

  useLenis(); // ✅ Smooth scrolling enable
  
  
  return (

<>
    <ScrollToTop />
    <WhatsAppButton
        phoneNumber="+919034050507"
        message="Hello! I’m interested, can we chat about your services? 💬"
      />
    <Header />

    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/about" element={<About />} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/our-team" element={<OurTeam />} />
      <Route path="/services" element={<OurServices />} />
      <Route path="/web-design-development" element={<WebDesignDevelopment />} />
      <Route path="/digital-marketing" element={<DigitalMarketing />} />
      <Route path="/graphic-designing" element={<GraphicDesigning />} />
      <Route path="/hosting-support" element={<HostingSupport />} />
      <Route path="/website-care" element={<WebsiteCare />} />
      <Route path="/portfolio" element={<Portfolio />} />
      <Route path="/blog" element={<Blog />} />
      <Route path="/blog/:slug" element={<BlogPost />} />
      <Route path="/contact" element={<Contact />} />
    </Routes>




    <Footer />

</>


  );
};

export default App;
